import { IgnoredReasonType, IgnoreOptions } from '../../../contexts/credit';
import useIgnoreByType from './useIgnoreByType';

export default function useIgnoreDropdownOptions(ignoreOptions: IgnoreOptions[]): IgnoredReasonType[] {
  const ignoredByType = useIgnoreByType();

  if (ignoredByType === null || !ignoreOptions) {
    return [];
  }

  return ignoreOptions?.reduce((acc, { reason, canIgnoreBy }) => (canIgnoreBy === ignoredByType ? [...acc, reason] : acc), [] as IgnoredReasonType[]);
}
